import {useState} from 'react';
import Modal from "../../modal/Modal";
import {useModal} from "../../modal/useModal";
import useYupValidationResolver from "../../../util/useYupValidationResolver";
import {FormProvider, useForm} from "react-hook-form";
import {showErrorNotification, showSuccessNotification} from "../../../util/notifications";
import Field from "../../form/Field";
import apiKeySchema from "./validation/apiKeySchema";
import useApi from "../../../api";
import classNames from 'classnames';
import {useQueryClient} from "react-query";

const EditApiKeyModal = ({modalId, apikey}) => {
    const {closeModal} = useModal();
    const [isLoading, setIsLoading] = useState(false);
    const {editApiKey} = useApi();
    const queryClient = useQueryClient();
    const resolver = useYupValidationResolver(apiKeySchema);
    const formMethods = useForm({
        resolver,
    });

    const {handleSubmit} = formMethods;

    const onSubmit = async (data) => {
        setIsLoading(true);
        console.log(data);
        try {
            const response = await editApiKey(apikey.id, data);
            await queryClient.invalidateQueries('apikeys');
            console.log(response);
            showSuccessNotification('API key name updated.');
        } catch (e) {
            console.error(e);
            showErrorNotification('Something went wrong updating the API key.');
        }
        closeModal(modalId);
    }

    const onError = (error) => {
        console.log(error);
    }

    const buttonClass = classNames('button', {
        'button--loading': isLoading,
    });

    const close = (e) => {
        e.preventDefault();
        closeModal(modalId);
    }

    return (
        <Modal modalId={modalId}>
            <h1 className="modal__title">Edit API Key</h1>
            <FormProvider {...formMethods} >
                <form onSubmit={handleSubmit(onSubmit, onError)} noValidate className="form">
                    <Field
                        label="Name"
                        type="text"
                        name="name"
                        maxLength={50}
                        defaultValue={apikey.name}
                    />
                    <div className="modal__footer">
                        <button className="button button--link" onClick={close}>Close</button>
                        <button className={buttonClass}>Save</button>
                    </div>
                </form>
            </FormProvider>
        </Modal>
    )
};

export default EditApiKeyModal;
